export const resetPassword =
    "//portal.daleoperating.com/wp-login.php?action=lostpassword";



// WEBPACK FOOTER //
// ./src/utils/dev-prod.js